import type { FaireProductEntity } from "../../entity_types/product";

export const atc_refined_moma_3: FaireProductEntity = {
  token: "atc_refined_moma_3",
  type: "product",
  name: "Geometric Pattern Bowls",
  brandName: "Pozzi Milano",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/a171be6efc7da6079f4312910ec5f37ed8c43537861694b34c5495db50c1950f.webp",
  priceDollars: 35,
  msrpDollars: 58,
  description: "Italian-designed tableware with Memphis-inspired aesthetic.",
  tags: ["tableware", "drinkware", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
